<template>
  <ExternalQueryList
      headline="Files"
      endpoint="/api/v2/content-files"
      :endpoint-filters="{portal_id: portal.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      @show="file => $router.push(getUrl(file))"
  >
    <template v-slot:default="{ row: file }">
      <td>
        <router-link :to="getUrl(file)">
          {{ file.attributes.title }}
        </router-link>
      </td>

      <td>
        {{ file.attributes.content_file_category_name }}
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/files/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  props: {
    portal: {
      required: true
    },

    fileCategories: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 14, text: 'Name'},
        {width: 6, text: 'File Category'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 16,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'select',
            name: 'content_file_category_id',
            placeholder: 'Search file categories...',
            nullable: true,
            options: this.fileCategories.map(fileCategory => ({
              value: fileCategory.id,
              label: fileCategory.attributes.name
            }))
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(file) {
      return '/portals/' + this.portal.id + '/content/files/' + file.id + '/edit'
    }
  }
}
</script>
